import React from 'react'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import type { ButtonProps } from '@material-ui/core/Button'

import { useNotificationsStyles } from './notification-list.styles'
import { NotificationTabContent } from '../common'
import { useTranslation } from '../../../utils'

type NotificationListProps = {
  settingsButtonProps?: ButtonProps
}

export const NotificationList: React.FC<NotificationListProps> = (props) => {
  const classes = useNotificationsStyles()
  const { data: translate } = useTranslation()
  return (
    <>
      <div className={classes.titleContainer}>
        <Typography variant="h4" className={classes.title}>
          {translate?.notifications['notifications-title']}
        </Typography>
        <Button
          color="secondary"
          variant="contained"
          className={classes.button}
          {...props.settingsButtonProps}
        >
          {translate?.shop['notification-settings']}
        </Button>
      </div>
      <div className={classes.root}>
        <NotificationTabContent className={classes.tabContainer} />
      </div>
    </>
  )
}
